import React from 'react';
import { CardSideProps } from './types';
import { StyledTag, Title, Wrapper } from './card-side.styles';
import { Typography } from '../typography/typography';

export const CardSide: React.FC<CardSideProps> = ({
    title,
    description,
    tagChildren,
    tagVariant,
    tagDeclineMessage,
    onMouseEnter,
    onClick,
}) => {
    return (
        <Wrapper isPointer={Boolean(onClick)} onMouseEnter={onMouseEnter} onClick={onClick}>
            <Title size='subtitle3'>{title}</Title>
            <Typography size='body2_long' color='neutral_50'>
                {description}
            </Typography>
            {tagChildren && (
                <StyledTag variant={tagVariant} declineMessage={tagDeclineMessage}>
                    {tagChildren}
                </StyledTag>
            )}
        </Wrapper>
    );
};
